const AnalyticsEvents = {

    PLAY_WITH_FRIENDS:'play_with_friends',
    CHALLENGE_RANDOM:'challenge_random',
    FAILED_TO_CHALLENGE_RANDOM:'failed_to_challenge_random',

    PLAYER_PLAY: 'player_play',
    PLAYER_COMPLETE : 'player_complete',

    /*---------- Rewarded Video ------------*/
    VIDEO_WATCHED: 'video_watched',
    FAILED_TO_LOAD_VIDEO: 'failed_to_load_video',
    FAILED_TO_SHOW_VIDEO: ' failed_to_show_video',

    /*------------ Interstitial ------------*/
    INTERSTITAL_SHOWN:'interstitial_shown',
    FAILED_TO_LOAD_INTERSTITIAL:'failed_to_load_interstitial',
    FAILED_TO_SHOW_INTERSTITIAL:'failed_to_show_interstitial',

    /*------------ Player Actions------------*/
    PLAYER_CONTINUE:'player_continue',
    PLAYER_END_RUN:'player_end_run',
    PLAYER_DEATH:'player_death',

    /*------------ End Screen------------*/
    END_SCREEN_SHOW_LEADERBOARDS:'end_screen_show_leaderboards',
    END_SCREEN_SHOW_SCORE:'end_screen_show_score',
    END_SCREEN_SWITCH_CONTEXT:'end_screen_switch_context',
    END_SCREEN_ADD_TO_HOME_SCREEN:'end_screen_add_to_home_screen',

    /*--------------- Misc --------------*/
    FAILED_TO_SWITCH_CONTEXT:'failed_to_switch_context',
    FAILED_TO_SUBMIT_SCORE:'failed_to_submit_score',
    FAILED_TO_SEND_UPDATE_MESSAGE:'failed_to_send_update_message',
    FAILED_TO_SET_STATS: 'failed_to_set_stats',
    FAILED_TO_GET_PLAYER_LEADERBOARD_ENTRY:'failed_to_get_player_leaderboard_entry',
    FAILED_TO_ADD_TO_HOME_SCREEN:'failed_to_add_to_home_screen',
    FAILED_TO_SHARE_SCORE:'failed_to_share_score',
    FAILED_TO_SUBSCRIBE_TO_BOT:'failed_to_subscribe_to_bot',
    FAILED_TO_START_GAME:'failed_to_start_game'
}

export default AnalyticsEvents;